import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
//Guard
import { AuthGuardService } from '@services/auth-guard/auth-guard.service';


// Pages
import {
  BookappointmentsComponent,
  RegisterComponent,
  ConfirmmailComponent,
  FaqComponent,
  SecondopinionComponent,
} from "@pages/index.pages";


// Routes configuration
const appRoutes: Routes = [
  { path: 'bookappointments', component: BookappointmentsComponent },
  { path: 'secondopinion', component: SecondopinionComponent },
  { path: 'register', component: RegisterComponent },
  {
    path: 'confirm',
    component: ConfirmmailComponent,
  },
  {
    path: 'faq',
    component: FaqComponent
  },
  {
    path: 'user',
    loadChildren: () => import('./pages/user-pages/user.module').then(m => m.UserModule),
  },
  {
    path: 'admin',
    loadChildren: () => import('./pages/admin-pages/admin.module').then(m => m.AdminModule),
    canActivate: [AuthGuardService],
  },
  { path: '**', redirectTo: 'bookappointments', pathMatch: 'full' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, { useHash: true, preloadingStrategy: PreloadAllModules })
  ],
  exports: [
    RouterModule
  ]
})

export class AppRoutingModule {
}
